<icc-toast-item *ngFor="let msg of messages; let i=index" [message]="msg" [index]="i" (onClose)="onMessageClose($event)"
        @toastAnimation
        [showTransformOptions]="showTransformOptions" [hideTransformOptions]="hideTransformOptions"
        [showTransitionOptions]="showTransitionOptions" [hideTransitionOptions]="hideTransitionOptions"></icc-toast-item>